export const NO_COLOR_BLINDNESS = 'none';
export const EXAMPLE_GOOD = 'good';
export const EXAMPLE_BAD = 'bad';
